/** JSON calls to the dashboard API (same origin, session cookie). Errors carry the API's code. */
import { AuthError } from './auth';

export async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');
  if (init.body !== undefined) headers.set('Content-Type', 'application/json');
  const response = await fetch(path, { credentials: 'same-origin', ...init, headers });
  if (!response.ok) {
    let code: string | null = null;
    try {
      const body: unknown = await response.json();
      if (typeof body === 'object' && body !== null && 'detail' in body) {
        code = typeof body.detail === 'string' ? body.detail : null;
      }
    } catch {
      // not JSON
    }
    throw new AuthError(response.status, code);
  }
  return (response.status === 204 ? undefined : await response.json()) as T;
}

export const send = (method: string, body?: unknown): RequestInit => ({
  method,
  body: body === undefined ? undefined : JSON.stringify(body),
});

/** Query string from the set values, in a stable order. */
export function query(params: Record<string, string | number | null | undefined>): string {
  const search = new URLSearchParams();
  for (const [name, value] of Object.entries(params)) {
    if (value !== null && value !== undefined && value !== '') search.set(name, String(value));
  }
  const text = search.toString();
  return text === '' ? '' : `?${text}`;
}

/** The browser's time zone, so days in charts start at the user's midnight. */
export function browserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
